export default "__VITE_ASSET__C3Zsih87__"